module.exports = __webpack_public_path__ + "static/media/lovenest.86a08863.png";